import configs from "./configs"
export default {
    "home": {
        "en": "home",
        "ar": "الصفحة الرئيسية"
    },

    "statistics-chart": {
        "en": "statistics",
        "ar": "الإحصائيات"
    },
    "visits": {
        "en": "visits",
        "ar": "الزيارات"
    },
    "day-off-requests": {
        "en": "requests",
        "ar": "الطلبات"
    },
    "staff": {
        "en": "staff",
        "ar": "طاقم العمل"
    },
    "reports": {
        "en": "reports",
        "ar": "التقارير"
    },
    "administrative-reports": {
        "en": "reports",
        "ar": "التقارير"
    },
    "double-visits": {
        "en": "reports",
        "ar": "التقارير"
    },
    "supervisors": {
        "en": "supervisors",
        "ar": "المشرفين"
    },

    "customers": {
        "en": "customers",
        "ar": "الزبائن"
    },
    "exams": {
        "en": "exams",
        "ar": "الاختبارات"
    },

    "salaries": {
        "en": "Salaries",
        "ar": "الرواتب"
    },
    "regions-management": {
        "en": "Regions Management",
        "ar": "إدارة المناطق"
    },
    "visited-doctors": {
        "en": "Visits Counts",
        "ar": "عدد الزيارات"
    },
    "medical-rep-samples": {
        "en": "",
        "ar": ""
    },
    "supervisor-remaining-samples": {
        "en": "Remaining Samples",
        "ar": `${configs.supervisorRemainingSamples.ar}`
    },
    "modification-requests": {
        "en": "Requests",
        "ar": "الطلبات "
    },
    "specializations-management": {
        "en": "Specializations Management",
        "ar": "إدارة التخصصات"
    },
    "medical-rep-rates": {
        "en": "",
        "ar": ""
    },
    "exam-results": {
        "en": "Exam Results",
        "ar": "نتائج الاختبارات"
    },

    "medical-rep-info-day-requests": {
        "en": "Employee Information",
        "ar": "معلومات الموظف"
    },
    "medical-samples": {
        "en": "Employee Information",
        "ar": "معلومات الموظف"
    },
    "medical-rates": {
        "en": "Employee Information",
        "ar": "معلومات الموظف"
    },
    "medical-rep-personal-data": {
        "en": "Employee Information",
        "ar": "معلومات الموظف"
    },
    "medical-rep-info": {
        "en": "Employee Information",
        "ar": "معلومات الموظف"
    },
    "supervisors-samples": {
        "en": "Employee information",
        "ar": "معلومات الموظف"
    },
    "supervisors-personal-data": {
        "en": "Employee information",
        "ar": "معلومات الموظف"
    },

    "journal-items": {
        "en": "Create samples",
        "ar": "يومية مواد"
    },
    "samples-statement": {
        "en": "Samples Statement",
        "ar": `${configs.samplesStatement.ar}`
    },
    "journal-delivery-of-samples": {
        "en": "Deliver items",
        "ar": `${configs.DeliverItems.ar}`
    },
    "products-statement": {
        "en": "Products Statement",
        "ar": "كشف مواد"
    },
    "supervisors-report": {
        "en": "Weekly report",
        "ar": "التقرير أسبوعي"
    },
    "weekly-report": {
        "en": "Administrative report",
        "ar": "تقرير الإدارين"
    },
    "products": {
        "en": "Products",
        "ar": "المواد"
    },

    "pharmaceutical-forms": {
        "en": "Pharmaceutical Forms",
        "ar": `${configs.pharmaceuticalForm.ar}`
    },

    "roles": {
        "en": "Manage roles and permissions",
        "ar": "إدارة الأدوار والأذونات"
    },
    "users": {
        "en": "Manage users",
        "ar": "ادارة المستخدمين"
    },
    "classification-management": {
        "en": "Classification Management",
        "ar": "إدارة التصنيف"
    },
    "visit-frequency-report": {
        "en": "Med.Rep.Mark",
        "ar": "تواتر زيارات المندوب"
    },
    "medical-rep-plan": {
        "en": "Medical Rep Plan",
        "ar": "خطة المندوب"
    },
    
    "double-visit-report": {
        "en": "Double Visit Report",
        "ar": "تقرير الزيارة المزدوجة"
    },
    "double-visits-reports": {
        "en": "Double Visits Reports",
        "ar": "تقارير الزيارات المزدوجة"
    },
    "users-tree": {
        "en": "Users tree",
        "ar": "شجرة المستخدمين"
    },
    "administrative-visit": {
        "en": "Administrative Visit",
        "ar": "زيارة إدارية"
    },
    "administrative-plan": {
        "en": "Administrative plan",
        "ar": "الخطة الإدارية"
    },

    "accounts-tree": {
        "en": "External Entities",
        "ar": "الجهات الخارجية"
    },
    "teams": {
        "en": "Teams",
        "ar": "فرق"
    },
    "minimal-interface": {
        "en": "Material stock limit",
        "ar": "مواد على وشك النفاذ"
    },
    "warehouses-statistics": {
        "en": "Warehouses statistics",
        "ar": "إحصائيات المستودع"
    },
    "daily-report": {
        "en": "Daily report",
        "ar": "التقرير اليومي"
    },
    "specialty-and-teams": {
        "en": "Team plan",
        "ar": "خطة الفريق" 
    },
    companies: {
        "en": "Companies management",
        "ar": "إدارة الشركات"
    },
    "choose-company": {
        "en": "Companies",
        "ar": "الشركات"
    },
    "customers-types": {
        "en": "Customers types",
        "ar": "أنواع الزبائن"
    },
    "prices-types": {
        "en": "Prices types",
        "ar": "أنواع الأسعار"
    },
    "employee-stock": {
        "en": "Employee stock",
        "ar": "أرصدة الموظفين"
    },
    "materials-stock-by-city-statistics": {
        "en": "Material stock",
        "ar": "مخزون المواد"
    },
    "vacations": {
        "en": "Vacations",
        "ar": "الإجازات"
    },
    "settings": {
        "en": "Settings",
        "ar": "إدارة إعدادات الصلاحيات حسب نوع الزبون"
    },
    "sepacilaties-statistics": {
        en: "Number of doctors by specialties and classifications in the city",
        ar: "عدد الاطباء حسب التخصصات و التصنيفات في المدينة"
    }
}